(ns pfo.message.component
  (:require
    [reagent.core :as reagent :refer [atom]]
    [pfo.message.model :as model]
    [pfo.state :as state]
    [pfo.util :as util :refer [set-page entity]]
    [pfo.form :as form]
    [pfo.widget.tabs :refer [tabs tab]]
    [pfo.api :as api :refer [process-error]]
    [pfo.assignment.component :refer [assignment-list]]
    [pfo.widget.paginator :refer [paginator tfoot-paginator]]
    [promesa.core :as p]))

(defn message-complete-by [message]
  (if-let [complete-by (get-in message [:related_object :complete_by])] complete-by (:complete_by (:meta message))))

(defn date-reformat [date-string]
  (when (not-empty date-string)
    (util/date-reformat date-string)))

(defn get-url [message]
  (let [metadata (:meta message)
        comment-param (str "/?comment_id=" (:comment_id metadata))]
    (condp = (:object_type metadata)
      ;; TODO: this kind of type dispatching is common with "links", should be generalized
      "t" (str "#/task/details/" (:object_id metadata) comment-param)
      "to" (str "#/task/details/" (:object_id metadata) "/" (message-complete-by message) comment-param)
      "d" (str "#/document/details/" (:object_id metadata) comment-param)
      "n" (str "#/document/details/" (:object_id metadata) comment-param)
      "e" (str "#/event/details/id/" (:object_id metadata) comment-param)
      "eo" (str "#/event/details/" (:key metadata) comment-param)
      "")))

(defn get-title [message]
  (let [metadata (:meta message)
        url (get-url message)
        related-object (:related_object message)
        no-permission (:related_object_no_permission message)]
    (when (= "c" (:type message))
      (condp = (:object_type metadata)
        "t" [:span "Task: " [:a {:href url :disabled :disabled} (:name metadata)]]
        "to" [:span "Task: " [:a {:href url :disabled :disabled} (date-reformat (message-complete-by message)) " " (:name metadata)]]
        "d" [:span "Document: " [:a {:href url} (if-let [docname (:name metadata)] docname "View")]]
        "n" [:span "Note: " [:a {:href url} (if-let [docname (:name metadata)] docname "View")]]
        "e" [:span "Event: " [:a {:href url} (:name metadata)]]
        "eo" [:span "Event: " [:a {:href url} (date-reformat (:complete_by metadata)) " " (:name metadata)]]
        ""))))

(defn message-assignment-list [message]
  [assignment-list (sort-by :main (comp - compare)
                     (map (fn [col] {:collection col
                                     :collection_id (:id col)
                                     :main (= (:id col) (:related_object_main_collection_id message))})
                       (:related_object_collections message)))])

(defn received-message-list []
  (let [messages (atom nil)
        current-page (atom 1)
        load-messages (fn [page]
                        (reset! current-page page)
                        (->> (model/received-messages page)
                             (p/map #(reset! messages %))
                             (process-error)))]
    (load-messages @current-page)
    (fn []
      (if (seq (:results @messages))
        [:table.messages.t-table
         [:thead
          [:tr
           [:th.title "Message"]
           [:th.from "From"]
           [:th.assignments "Collections"]]]

         [:tbody 
          (doall
            (for [received-message (:results @messages)]
              (let [message (:message received-message)
                    metadata (:meta message)
                    body (if (and (= "c" (:type message)) (= "delete" (:action metadata)))
                           "Comment deleted"
                           (or (:plaintext_body metadata) (:body message))) 
                    url (get-url message)]
                [:tr {:key (:created_at received-message)}
                 [:td.title [:a {:href url} [:em (get-title message)] [:br] body]]
                 [:td.from (:from_first_name message) " " (:from_last_name message)]
                 [:td.assignments [message-assignment-list message]]])))]

         [tfoot-paginator

          [paginator 
           (map (fn [page-number]
                  {:number page-number
                   :on-click (util/handler #(load-messages page-number))})
                (:page_numbers @messages))
           @current-page
           (when (:has_previous @messages) (util/handler #(load-messages (- @current-page 1))))
           (when (:has_next @messages) (util/handler #(load-messages (+ @current-page 1))))] 3 
          (-> (:page_numbers @messages) count (> 1))]] 

        [:p.o-media "No messages."]))))

(defn sent-message-list  []
  (let [messages (atom nil)
        current-page (atom 1)
        load-messages (fn [page]
                        (reset! current-page page)
                        (->> (model/sent-messages page)
                             (p/map #(reset! messages %))
                             (process-error)))]
    (load-messages @current-page)
    (fn []
      (if (seq (:results @messages))
        [:div
         [:table.messages.t-table
          [:thead
           [:tr
            [:th.title "Message"]
            [:th.from "To"]
            [:th.assignments "Collections"]]]

           [:tbody
            (doall
              (for [message (:results @messages)]
                (let [metadata (:meta message)
                      body (if (and (= "c" (:type message)) (= "delete" (:action metadata)))
                             "Comment deleted"
                             (or (:plaintext_body metadata) (:body message))) 
                      url (get-url message)]
                  [:tr {:key (:created_at message)}
                   [:td.title [:a {:href url} [:em (get-title message)] [:br] body]]
                   [:td.from (clojure.string/join ", " (map #(str (:to_first_name %) " " (:to_last_name %)) (:received_messages message))) ]
                   [:td.assignments [message-assignment-list message]]])))]

           [tfoot-paginator

            [paginator 
             (map (fn [page-number]
                    {:number page-number
                     :on-click (util/handler #(load-messages page-number))})
                  (:page_numbers @messages))
             @current-page
             (when (:has_previous @messages) (util/handler #(load-messages (- @current-page 1))))
             (when (:has_next @messages) (util/handler #(load-messages (+ @current-page 1))))] 3
            (-> (:page_numbers @messages) count (> 1))]]]

        [:p.o-media "No messages."]))))

(defn message-list []
  (let [tab (atom :received)]
    (fn []
      [:div
       [:div.o-media--1x05.u-bottom-shadow
        [:label [:input (form/set-checked (= :received @tab) {:on-change #(reset! tab :received)})] "Received"] " "
        [:label [:input (form/set-checked (= :sent @tab) {:on-change #(reset! tab :sent)})] "Sent"]]
       (case @tab
        :received [received-message-list]
        :sent [sent-message-list])])))
